import { Dialog } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';

import { IntroVideoStatus } from '@site-mate/dashpivot-shared-library';

import { SignUpIntroVideoDialogComponent } from 'app/user/sign-up-simplified/sign-up-steps/sign-up-intro-video-dialog/sign-up-intro-video-dialog.component';
import { UserService } from 'app/user/user.service';

@Injectable()
export class IntroVideoService {
  isIntroVideoModalOpen: boolean;

  constructor(
    private readonly userService: UserService,
    private readonly dialog: Dialog,
  ) {}

  showIntroVideoDialog() {
    if (this.isIntroVideoModalOpen) {
      return;
    }

    const currentUser = this.userService.getCurrentUser();
    if (
      currentUser.signUpProgress?.templateId &&
      currentUser.signUpProgress?.introVideoStatus === IntroVideoStatus.NotDisplayed
    ) {
      const introVideoDialog = this.dialog.open(SignUpIntroVideoDialogComponent, {
        disableClose: true,
        data: {
          dismissable: true,
        },
      });
      this.isIntroVideoModalOpen = true;

      introVideoDialog.closed.subscribe(() => {
        this.isIntroVideoModalOpen = false;
      });
    }
  }
}
